import styled from 'styled-components';
import { grayLight } from '@bufferapp/ui/style/colors';

export const PostPreviewFooter = styled.div<{ alignContentToRight?: boolean }>`
  border-top: 1px solid ${grayLight};
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.alignContentToRight ? 'flex-end' : 'flex-start'};
  min-height: 32px;
`;
